import { Component, ChangeDetectionStrategy } from '@angular/core';
import { EllipsisLoadingComponent } from 'src/app/shared/components/ellipsis-loading/ellipsis-loading.component';

@Component({
    selector: 'app-page-loader',
    templateUrl: './page-loader.component.html',
    styleUrls: ['./page-loader.component.scss'],
    imports: [EllipsisLoadingComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageLoaderComponent {}
